import { memo } from 'react';

import { isValidPhone } from '../../format/phone';
import { useFormat } from '../useFormat';
import { DEFAULT_EMPTY_VALUE, type EmptyProps } from './shared';

export type PhoneNumberProps = EmptyProps & {
  /** The number, in whatever punctuation it was stored with. */
  readonly value: string | null | undefined;
};

/**
 * A phone number formatted for the reader: nationally on their own calling code, internationally
 * otherwise. A value that is not a dialable number renders as empty, the same as a blank one.
 */
const PhoneNumber = memo(
  ({
    value,
    emptyValue = DEFAULT_EMPTY_VALUE,
  }: PhoneNumberProps): JSX.Element => {
    const format = useFormat();

    if (
      value === null ||
      value === undefined ||
      value.trim() === '' ||
      !isValidPhone(value)
    ) {
      return <>{emptyValue}</>;
    }

    return <>{format.phone(value)}</>;
  }
);

PhoneNumber.displayName = 'PhoneNumber';

export default PhoneNumber;
